import fetcher from 'api/fetcher';

interface StopPromoCodeRequest {
    activationsLimit: number;
}

export const stopPromoCode = (promoCode: string): Promise<unknown> => {
    const requestBody: StopPromoCodeRequest = {
        activationsLimit: 0,
    };

    return fetcher.put(`/api/v1/backoffice/promo_codes/code/${promoCode}`, requestBody);
};
